const stateKeySuffix = "9734kjdfu98dfjf-uu6354tzuy";

const toStateKey = (key) => "state_" + key + "_" + stateKeySuffix;

//state
export const loadState = (key) => {
  try {
    const serializedState = sessionStorage.getItem(toStateKey(key)) || localStorage.getItem(toStateKey(key));
    if (serializedState === null) return;
    return { [key]: JSON.parse(serializedState) };
  } catch (error) {
    // Ignore load errors.
  }
}
export const saveState = (key, state) => {
  try {
    //console.log("persist", key, state.persistIn);
    const stateKey = toStateKey(key);
    const serializedState = state.persistIn ? JSON.stringify(state) : null;
    switch (state.persistIn) {
      case "session":
        sessionStorage.setItem(stateKey, serializedState);
        localStorage.removeItem(stateKey);
        break;
      case "local":
        localStorage.setItem(stateKey, serializedState);
        sessionStorage.removeItem(stateKey);
        break;
      default:
        sessionStorage.removeItem(stateKey);
        localStorage.removeItem(stateKey);
        break;
    }
  } catch (error) {
    // Ignore write errors.
  }
};
